module.exports = __webpack_public_path__ + "media/chime.ce409f32.ogg";